import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import img11 from "./Assets/11.png";
import img12 from "./Assets/12.png";
import img13 from "./Assets/13.png";
import img14 from "./Assets/14.png";
import img15 from "./Assets/15.png";
import img16 from "./Assets/16.png";
import img17 from "./Assets/17.png";
import img18 from "./Assets/18.png";
import img19 from "./Assets/19.png";
import img20 from "./Assets/20.png";
import logo from "./Assets/boc.png";

export default class BookOfChickensConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [
            img0,
            img1,
            img2,
            img3,
            img4,
            img5,
            img6,
            img7,
            img8,
            img9,
            img10,
            img11,
            img12,
            img13,
            img14,
            img15,
            img16,
            img17,
            img18,
            img19,
            img20,
        ];
        this.logo = logo;

        //Game Name
        this.name = "Book Of Chickens";

        //General Config
        this.reels = 3;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        // Book of chickens seemed to be ok for some reason, so leaving as 0
        this.highestSymId = 0;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94: {
                weights: {
                    baseGame: [666103, 230000, 97000, 6897],
                    freeSpins: {
                        fL1: [62990, 4667, 241085, 691258],
                        fL2: [62990, 4667, 241085, 691258],
                        fL3: [62990, 4667, 241085, 691258],
                        fL4: [62990, 4667, 241085, 691258],
                        fH6: [56079, 4605, 81418, 857898],
                        fH5: [56079, 4605, 80726, 858590],
                        fH4: [56348, 4595, 60013, 879044],
                        fH3: [56550, 4594, 68555, 870301],
                        fH2: [37334, 4834, 199320, 758512],
                        fH1: [32172, 4715, 34542, 928571],
                    },
                },
                reelSets: {
                    0: [
                        [
                            14, 14, 14, 0, 10, 12, 12, 12, 20, 20, 6, 12, 20, 20, 20, 18, 18, 4, 18, 18, 18, 20, 0, 18,
                            18, 14, 14, 14, 12, 18, 18, 14, 18, 20, 20, 10, 10, 14, 14, 20, 20, 20, 12, 12, 6, 14, 14,
                            18, 20, 10,
                        ],
                        [
                            16, 16, 16, 18, 0, 12, 12, 12, 18, 12, 12, 18, 18, 16, 18, 18, 16, 16, 2, 10, 16, 16, 10,
                            16, 16, 16, 8, 10, 10, 2, 12, 0, 18, 18, 18, 12, 8, 8, 16, 18, 18, 18,
                        ],
                        [
                            14, 14, 16, 16, 14, 14, 14, 16, 20, 14, 14, 14, 20, 20, 8, 20, 20, 8, 8, 6, 6, 16, 16, 16,
                            14, 14, 14, 4, 16, 16, 16, 20, 20, 20, 16, 20, 20, 20, 14, 16, 16, 2,
                        ],
                    ],
                    1: [
                        [
                            14, 14, 14, 20, 16, 16, 18, 18, 18, 14, 20, 14, 8, 18, 18, 18, 16, 8, 14, 16, 20, 20, 20, 8,
                            20, 18, 14, 14, 16, 14, 14, 8, 8, 20, 20, 16, 20, 20, 20, 4, 16, 16, 16, 18, 20, 20, 0, 18,
                            18, 18, 14, 16, 16, 14, 14, 14, 20, 18, 18, 0, 16, 16, 16, 18,
                        ],
                        [
                            14, 14, 14, 18, 20, 14, 14, 14, 18, 18, 18, 16, 20, 20, 20, 14, 18, 18, 18, 10, 16, 20, 10,
                            10, 6, 16, 20, 18, 18, 20, 20, 6, 16, 16, 18, 10, 20, 16, 16, 16, 18, 18, 18, 14, 16, 16,
                            14, 10, 14, 14, 6, 14, 14, 20, 20, 20, 18, 16, 14, 16, 16, 16, 20, 20,
                        ],
                        [
                            16, 16, 14, 14, 14, 16, 14, 20, 20, 20, 14, 14, 20, 16, 20, 18, 14, 14, 20, 20, 18, 18, 18,
                            0, 16, 16, 16, 12, 18, 18, 18, 20, 18, 18, 20, 20, 14, 16, 16, 16, 12, 18, 20, 14, 14, 14,
                            16, 16, 18, 18, 20, 20, 20, 0, 16, 16, 2, 12, 12, 14, 14, 18,
                        ],
                    ],
                    2: [
                        [
                            12, 8, 10, 12, 12, 18, 4, 10, 16, 6, 14, 8, 12, 20, 8, 8, 12, 12, 4, 20, 2, 10, 10, 6, 14,
                            18, 6, 6, 16,
                        ],
                        [
                            6, 6, 6, 12, 12, 10, 4, 2, 12, 0, 16, 14, 18, 6, 12, 12, 10, 18, 4, 12, 10, 10, 8, 8, 16,
                            20, 8, 0, 14, 20, 8,
                        ],
                        [
                            8, 20, 10, 10, 14, 12, 10, 12, 12, 2, 4, 6, 4, 18, 20, 16, 6, 8, 8, 0, 18, 10, 8, 12, 0, 6,
                            6, 12, 12, 16, 14,
                        ],
                    ],
                    3: [
                        [
                            0, 16, 8, 0, 14, 20, 0, 10, 18, 0, 20, 16, 0, 10, 18, 0, 12, 6, 0, 14, 16, 0, 18, 12, 0, 20,
                            14,
                        ],
                        [
                            0, 20, 16, 0, 14, 18, 0, 20, 12, 0, 16, 10, 0, 14, 6, 0, 18, 12, 0, 20, 16, 0, 8, 10, 0, 14,
                            18,
                        ],
                        [
                            0, 14, 12, 0, 18, 14, 0, 20, 18, 0, 8, 10, 0, 20, 18, 0, 6, 20, 0, 12, 16, 0, 16, 10, 0, 14,
                            16,
                        ],
                    ],
                    fL1_0: [
                        [19, 14, 16, 19, 18, 12, 19, 12, 10, 19, 8, 18, 19, 10, 18, 19, 14, 6, 19, 14, 16, 19, 12, 16],
                        [19, 10, 14, 19, 18, 12, 19, 18, 16, 19, 14, 8, 19, 16, 12, 19, 16, 18, 19, 12, 14, 19, 6, 10],
                        [19, 12, 16, 19, 18, 14, 19, 12, 10, 19, 6, 14, 19, 8, 16, 19, 18, 14, 19, 16, 18, 19, 10, 12],
                    ],
                    fL1_1: [
                        [0, 12, 18, 0, 10, 14, 0, 8, 16, 0, 18, 16, 0, 14, 6],
                        [0, 12, 8, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 6, 18],
                        [0, 16, 10, 0, 14, 12, 0, 18, 6, 0, 16, 14, 0, 8, 18],
                    ],
                    fL1_2: [
                        [
                            8, 12, 12, 2, 10, 18, 16, 12, 4, 16, 6, 4, 6, 6, 8, 8, 10, 6, 0, 4, 12, 12, 8, 8, 10, 12,
                            12, 2, 4, 4, 8, 18, 14, 4, 4, 6, 6, 8, 10, 14, 2, 0, 6, 10, 10, 12, 12,
                        ],
                        [
                            0, 4, 14, 10, 2, 16, 12, 12, 4, 4, 6, 6, 19, 8, 6, 2, 10, 19, 10, 16, 8, 8, 4, 4, 8, 8, 4,
                            2, 18, 12, 10, 12, 12, 18, 6, 8, 6, 10, 10, 8, 14, 12, 12, 0, 12, 12, 6, 6, 4,
                        ],
                        [
                            8, 8, 6, 12, 12, 14, 2, 10, 4, 4, 12, 12, 4, 4, 6, 8, 10, 12, 12, 19, 4, 10, 10, 19, 4, 12,
                            12, 8, 6, 6, 14, 10, 18, 6, 16, 8, 8, 18, 6, 6, 2, 16, 8, 2, 4, 10, 12,
                        ],
                    ],
                    fL1_3: [
                        [
                            18, 19, 18, 16, 18, 18, 18, 14, 18, 16, 14, 14, 14, 12, 18, 18, 14, 16, 18, 18, 18, 14, 16,
                            14, 14, 6, 16, 16, 16, 14, 14, 18, 14, 14, 14, 16, 16, 18, 18, 18, 14, 14, 14, 16, 18, 18,
                            14, 16, 16, 16, 18, 16, 14, 16, 16, 16, 14, 18, 16, 16, 19, 10,
                        ],
                        [
                            18, 16, 16, 18, 18, 18, 14, 18, 18, 16, 18, 18, 18, 14, 16, 18, 16, 16, 8, 16, 16, 16, 14,
                            14, 18, 18, 18, 16, 0, 14, 14, 16, 16, 16, 14, 16, 10, 14, 14, 14, 16, 16, 16, 18, 0, 14,
                            14, 14, 18, 16, 12, 14, 14, 14, 16, 14, 18, 19, 18, 18, 14, 19, 18, 14,
                        ],
                        [
                            16, 18, 16, 14, 18, 18, 18, 0, 18, 18, 18, 14, 18, 16, 14, 14, 14, 18, 18, 14, 14, 16, 16,
                            18, 14, 14, 18, 18, 18, 14, 16, 16, 16, 18, 14, 14, 14, 0, 16, 18, 18, 12, 8, 16, 16, 16,
                            14, 16, 16, 16, 14, 18, 16, 14, 14, 14, 16, 16, 14, 16, 18, 6,
                        ],
                    ],
                    fL2_0: [
                        [17, 14, 16, 17, 20, 12, 17, 12, 10, 17, 8, 20, 17, 10, 20, 17, 14, 6, 17, 14, 16, 17, 12, 16],
                        [17, 10, 14, 17, 20, 12, 17, 20, 16, 17, 14, 8, 17, 16, 12, 17, 16, 20, 17, 12, 14, 17, 6, 10],
                        [17, 12, 16, 17, 20, 14, 17, 12, 10, 17, 6, 14, 17, 8, 16, 17, 20, 14, 17, 16, 20, 17, 10, 12],
                    ],
                    fL2_1: [
                        [0, 12, 20, 0, 10, 14, 0, 8, 16, 0, 20, 16, 0, 14, 6],
                        [0, 12, 8, 0, 20, 14, 0, 16, 10, 0, 16, 14, 0, 6, 20],
                        [0, 16, 10, 0, 14, 12, 0, 20, 6, 0, 16, 14, 0, 8, 20],
                    ],
                    fL2_2: [
                        [
                            8, 12, 12, 2, 10, 20, 16, 12, 4, 16, 6, 4, 6, 6, 8, 8, 10, 6, 0, 4, 12, 12, 8, 8, 10, 12,
                            12, 2, 4, 4, 8, 20, 14, 4, 4, 6, 6, 8, 10, 14, 2, 0, 6, 10, 10, 12, 12,
                        ],
                        [
                            0, 4, 14, 10, 2, 16, 12, 12, 4, 4, 6, 6, 17, 8, 6, 2, 10, 17, 10, 16, 8, 8, 4, 4, 8, 8, 4,
                            2, 20, 12, 10, 12, 12, 20, 6, 8, 6, 10, 10, 8, 14, 12, 12, 0, 12, 12, 6, 6, 4,
                        ],
                        [
                            8, 8, 6, 12, 12, 14, 2, 10, 4, 4, 12, 12, 4, 4, 6, 8, 10, 12, 12, 17, 4, 10, 10, 17, 4, 12,
                            12, 8, 6, 6, 14, 10, 20, 6, 16, 8, 8, 20, 6, 6, 2, 16, 8, 2, 4, 10, 12,
                        ],
                    ],
                    fL2_3: [
                        [
                            20, 17, 20, 16, 20, 20, 20, 14, 20, 16, 14, 14, 14, 12, 20, 20, 14, 16, 20, 20, 20, 14, 16,
                            14, 14, 6, 16, 16, 16, 14, 14, 20, 14, 14, 14, 16, 16, 20, 20, 20, 14, 14, 14, 16, 20, 20,
                            14, 16, 16, 16, 20, 16, 14, 16, 16, 16, 14, 20, 16, 16, 17, 10,
                        ],
                        [
                            20, 16, 16, 20, 20, 20, 14, 20, 20, 16, 20, 20, 20, 14, 16, 20, 16, 16, 8, 16, 16, 16, 14,
                            14, 20, 20, 20, 16, 0, 14, 14, 16, 16, 16, 14, 16, 10, 14, 14, 14, 16, 16, 16, 20, 0, 14,
                            14, 14, 20, 16, 12, 14, 14, 14, 16, 14, 20, 17, 20, 20, 14, 17, 20, 14,
                        ],
                        [
                            16, 20, 16, 14, 20, 20, 20, 0, 20, 20, 20, 14, 20, 16, 14, 14, 14, 20, 20, 14, 14, 16, 16,
                            20, 14, 14, 20, 20, 20, 14, 16, 16, 16, 20, 14, 14, 14, 0, 16, 20, 20, 12, 8, 16, 16, 16,
                            14, 16, 16, 16, 14, 20, 16, 14, 14, 14, 16, 16, 14, 16, 20, 6,
                        ],
                    ],
                    fL3_0: [
                        [15, 14, 20, 15, 18, 12, 15, 12, 10, 15, 8, 18, 15, 10, 18, 15, 14, 6, 15, 14, 20, 15, 12, 20],
                        [15, 10, 14, 15, 18, 12, 15, 18, 20, 15, 14, 8, 15, 20, 12, 15, 20, 18, 15, 12, 14, 15, 6, 10],
                        [15, 12, 20, 15, 18, 14, 15, 12, 10, 15, 6, 14, 15, 8, 20, 15, 18, 14, 15, 20, 18, 15, 10, 12],
                    ],
                    fL3_1: [
                        [0, 12, 18, 0, 10, 14, 0, 8, 20, 0, 18, 20, 0, 14, 6],
                        [0, 12, 8, 0, 18, 14, 0, 20, 10, 0, 20, 14, 0, 6, 18],
                        [0, 20, 10, 0, 14, 12, 0, 18, 6, 0, 20, 14, 0, 8, 18],
                    ],
                    fL3_2: [
                        [
                            8, 12, 12, 2, 10, 18, 20, 12, 4, 20, 6, 4, 6, 6, 8, 8, 10, 6, 0, 4, 12, 12, 8, 8, 10, 12,
                            12, 2, 4, 4, 8, 18, 14, 4, 4, 6, 6, 8, 10, 14, 2, 0, 6, 10, 10, 12, 12,
                        ],
                        [
                            0, 4, 14, 10, 2, 20, 12, 12, 4, 4, 6, 6, 15, 8, 6, 2, 10, 15, 10, 20, 8, 8, 4, 4, 8, 8, 4,
                            2, 18, 12, 10, 12, 12, 18, 6, 8, 6, 10, 10, 8, 14, 12, 12, 0, 12, 12, 6, 6, 4,
                        ],
                        [
                            8, 8, 6, 12, 12, 14, 2, 10, 4, 4, 12, 12, 4, 4, 6, 8, 10, 12, 12, 15, 4, 10, 10, 15, 4, 12,
                            12, 8, 6, 6, 14, 10, 18, 6, 20, 8, 8, 18, 6, 6, 2, 20, 8, 2, 4, 10, 12,
                        ],
                    ],
                    fL3_3: [
                        [
                            18, 15, 18, 20, 18, 18, 18, 14, 18, 20, 14, 14, 14, 12, 18, 18, 14, 20, 18, 18, 18, 14, 20,
                            14, 14, 6, 20, 20, 20, 14, 14, 18, 14, 14, 14, 20, 20, 18, 18, 18, 14, 14, 14, 20, 18, 18,
                            14, 20, 20, 20, 18, 20, 14, 20, 20, 20, 14, 18, 20, 20, 15, 10,
                        ],
                        [
                            18, 20, 20, 18, 18, 18, 14, 18, 18, 20, 18, 18, 18, 14, 20, 18, 20, 20, 8, 20, 20, 20, 14,
                            14, 18, 18, 18, 20, 0, 14, 14, 20, 20, 20, 14, 20, 10, 14, 14, 14, 20, 20, 20, 18, 0, 14,
                            14, 14, 18, 20, 12, 14, 14, 14, 20, 14, 18, 15, 18, 18, 14, 15, 18, 14,
                        ],
                        [
                            20, 18, 20, 14, 18, 18, 18, 0, 18, 18, 18, 14, 18, 20, 14, 14, 14, 18, 18, 14, 14, 20, 20,
                            18, 14, 14, 18, 18, 18, 14, 20, 20, 20, 18, 14, 14, 14, 0, 20, 18, 18, 12, 8, 20, 20, 20,
                            14, 20, 20, 20, 14, 18, 20, 14, 14, 14, 20, 20, 14, 20, 18, 6,
                        ],
                    ],
                    fL4_0: [
                        [13, 20, 16, 13, 18, 12, 13, 12, 10, 13, 8, 18, 13, 10, 18, 13, 20, 6, 13, 20, 16, 13, 12, 16],
                        [13, 10, 20, 13, 18, 12, 13, 18, 16, 13, 20, 8, 13, 16, 12, 13, 16, 18, 13, 12, 20, 13, 6, 10],
                        [13, 12, 16, 13, 18, 20, 13, 12, 10, 13, 6, 20, 13, 8, 16, 13, 18, 20, 13, 16, 18, 13, 10, 12],
                    ],
                    fL4_1: [
                        [0, 12, 18, 0, 10, 20, 0, 8, 16, 0, 18, 16, 0, 20, 6],
                        [0, 12, 8, 0, 18, 20, 0, 16, 10, 0, 16, 20, 0, 6, 18],
                        [0, 16, 10, 0, 20, 12, 0, 18, 6, 0, 16, 20, 0, 8, 18],
                    ],
                    fL4_2: [
                        [
                            8, 12, 12, 2, 10, 18, 16, 12, 4, 16, 6, 4, 6, 6, 8, 8, 10, 6, 0, 4, 12, 12, 8, 8, 10, 12,
                            12, 2, 4, 4, 8, 18, 20, 4, 4, 6, 6, 8, 10, 20, 2, 0, 6, 10, 10, 12, 12,
                        ],
                        [
                            0, 4, 20, 10, 2, 16, 12, 12, 4, 4, 6, 6, 13, 8, 6, 2, 10, 13, 10, 16, 8, 8, 4, 4, 8, 8, 4,
                            2, 18, 12, 10, 12, 12, 18, 6, 8, 6, 10, 10, 8, 20, 12, 12, 0, 12, 12, 6, 6, 4,
                        ],
                        [
                            8, 8, 6, 12, 12, 20, 2, 10, 4, 4, 12, 12, 4, 4, 6, 8, 10, 12, 12, 13, 4, 10, 10, 13, 4, 12,
                            12, 8, 6, 6, 20, 10, 18, 6, 16, 8, 8, 18, 6, 6, 2, 16, 8, 2, 4, 10, 12,
                        ],
                    ],
                    fL4_3: [
                        [
                            18, 13, 18, 16, 18, 18, 18, 20, 18, 16, 20, 20, 20, 12, 18, 18, 20, 16, 18, 18, 18, 20, 16,
                            20, 20, 6, 16, 16, 16, 20, 20, 18, 20, 20, 20, 16, 16, 18, 18, 18, 20, 20, 20, 16, 18, 18,
                            20, 16, 16, 16, 18, 16, 20, 16, 16, 16, 20, 18, 16, 16, 13, 10,
                        ],
                        [
                            18, 16, 16, 18, 18, 18, 20, 18, 18, 16, 18, 18, 18, 20, 16, 18, 16, 16, 8, 16, 16, 16, 20,
                            20, 18, 18, 18, 16, 0, 20, 20, 16, 16, 16, 20, 16, 10, 20, 20, 20, 16, 16, 16, 18, 0, 20,
                            20, 20, 18, 16, 12, 20, 20, 20, 16, 20, 18, 13, 18, 18, 20, 13, 18, 20,
                        ],
                        [
                            16, 18, 16, 20, 18, 18, 18, 0, 18, 18, 18, 20, 18, 16, 20, 20, 20, 18, 18, 20, 20, 16, 16,
                            18, 20, 20, 18, 18, 18, 20, 16, 16, 16, 18, 20, 20, 20, 0, 16, 18, 18, 12, 8, 16, 16, 16,
                            20, 16, 16, 16, 20, 18, 16, 20, 20, 20, 16, 16, 20, 16, 18, 6,
                        ],
                    ],
                    fH6_0: [
                        [11, 14, 16, 11, 18, 20, 11, 20, 10, 11, 8, 18, 11, 10, 18, 11, 14, 6, 11, 14, 16, 11, 20, 16],
                        [11, 10, 14, 11, 18, 20, 11, 18, 16, 11, 14, 8, 11, 16, 20, 11, 16, 18, 11, 20, 14, 11, 6, 10],
                        [11, 20, 16, 11, 18, 14, 11, 20, 10, 11, 6, 14, 11, 8, 16, 11, 18, 14, 11, 16, 18, 11, 10, 20],
                    ],
                    fH6_1: [
                        [0, 20, 18, 0, 10, 14, 0, 8, 16, 0, 18, 16, 0, 14, 6],
                        [0, 20, 8, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 6, 18],
                        [0, 16, 10, 0, 14, 20, 0, 18, 6, 0, 16, 14, 0, 8, 18],
                    ],
                    fH6_2: [
                        [
                            10, 2, 0, 18, 4, 4, 6, 4, 16, 6, 6, 8, 8, 4, 20, 6, 6, 14, 10, 18, 0, 14, 8, 2, 16, 8, 4, 4,
                            20, 10, 10, 6,
                        ],
                        [
                            4, 8, 8, 11, 2, 4, 4, 18, 14, 20, 10, 10, 8, 4, 20, 8, 2, 10, 6, 4, 4, 0, 6, 6, 16, 0, 6,
                            10, 11, 14, 18, 16, 6, 6,
                        ],
                        [
                            6, 10, 16, 14, 6, 6, 4, 20, 18, 8, 11, 10, 6, 6, 4, 4, 20, 2, 16, 8, 4, 4, 18, 14, 8, 8, 4,
                            10, 10, 11, 2, 6,
                        ],
                    ],
                    fH6_3: [
                        [
                            16, 16, 18, 18, 16, 16, 16, 18, 18, 18, 11, 14, 14, 10, 10, 18, 18, 18, 16, 16, 11, 16, 16,
                            16, 20, 20, 10, 8, 18, 18, 8,
                        ],
                        [
                            14, 14, 11, 16, 16, 18, 18, 10, 18, 18, 18, 10, 10, 16, 16, 16, 8, 20, 20, 18, 18, 18, 8,
                            16, 16, 0, 18, 18, 16, 16, 16, 11, 0,
                        ],
                        [
                            16, 16, 8, 16, 16, 16, 0, 8, 18, 18, 18, 10, 10, 0, 16, 16, 16, 18, 18, 18, 14, 14, 18, 18,
                            16, 16, 20, 20, 10, 18, 18,
                        ],
                    ],
                    fH5_0: [
                        [9, 14, 16, 9, 18, 12, 9, 12, 20, 9, 8, 18, 9, 20, 18, 9, 14, 6, 9, 14, 16, 9, 12, 16],
                        [9, 20, 14, 9, 18, 12, 9, 18, 16, 9, 14, 8, 9, 16, 12, 9, 16, 18, 9, 12, 14, 9, 6, 20],
                        [9, 12, 16, 9, 18, 14, 9, 12, 20, 9, 6, 14, 9, 8, 16, 9, 18, 14, 9, 16, 18, 9, 20, 12],
                    ],
                    fH5_1: [
                        [0, 12, 18, 0, 20, 14, 0, 8, 16, 0, 18, 16, 0, 14, 6],
                        [0, 12, 8, 0, 18, 14, 0, 16, 20, 0, 16, 14, 0, 6, 18],
                        [0, 16, 20, 0, 14, 12, 0, 18, 6, 0, 16, 14, 0, 8, 18],
                    ],
                    fH5_2: [
                        [
                            12, 2, 0, 18, 4, 4, 6, 4, 16, 6, 6, 8, 8, 4, 20, 6, 6, 14, 12, 18, 0, 14, 8, 2, 16, 8, 4, 4,
                            20, 12, 12, 6,
                        ],
                        [
                            4, 8, 8, 9, 2, 4, 4, 18, 14, 20, 12, 12, 8, 4, 20, 8, 2, 12, 6, 4, 4, 0, 6, 6, 16, 0, 6, 12,
                            9, 14, 18, 16, 6, 6,
                        ],
                        [
                            6, 12, 16, 14, 6, 6, 4, 20, 18, 8, 9, 12, 6, 6, 4, 4, 20, 2, 16, 8, 4, 4, 18, 14, 8, 8, 4,
                            12, 12, 9, 2, 6,
                        ],
                    ],
                    fH5_3: [
                        [
                            16, 16, 18, 18, 16, 16, 16, 18, 18, 18, 9, 14, 14, 12, 12, 18, 18, 18, 16, 16, 9, 16, 16,
                            16, 20, 20, 12, 8, 18, 18, 8,
                        ],
                        [
                            14, 14, 9, 16, 16, 18, 18, 12, 18, 18, 18, 12, 12, 16, 16, 16, 8, 20, 20, 18, 18, 18, 8, 16,
                            16, 0, 18, 18, 16, 16, 16, 9, 0,
                        ],
                        [
                            16, 16, 8, 16, 16, 16, 0, 8, 18, 18, 18, 12, 12, 0, 16, 16, 16, 18, 18, 18, 14, 14, 18, 18,
                            16, 16, 20, 20, 12, 18, 18,
                        ],
                    ],
                    fH4_0: [
                        [7, 14, 16, 7, 18, 12, 7, 12, 10, 7, 20, 18, 7, 10, 18, 7, 14, 6, 7, 14, 16, 7, 12, 16],
                        [7, 10, 14, 7, 18, 12, 7, 18, 16, 7, 14, 20, 7, 16, 12, 7, 16, 18, 7, 12, 14, 7, 6, 10],
                        [7, 12, 16, 7, 18, 14, 7, 12, 10, 7, 6, 14, 7, 20, 16, 7, 18, 14, 7, 16, 18, 7, 10, 12],
                    ],
                    fH4_1: [
                        [0, 12, 18, 0, 10, 14, 0, 20, 16, 0, 18, 16, 0, 14, 6],
                        [0, 12, 20, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 6, 18],
                        [0, 16, 10, 0, 14, 12, 0, 18, 6, 0, 16, 14, 0, 20, 18],
                    ],
                    fH4_2: [
                        [
                            10, 2, 0, 18, 4, 4, 6, 4, 16, 6, 6, 12, 12, 4, 20, 6, 6, 14, 10, 18, 0, 14, 12, 2, 16, 12,
                            4, 4, 20, 10, 10, 6,
                        ],
                        [
                            4, 12, 12, 7, 2, 4, 4, 18, 14, 20, 10, 10, 12, 4, 20, 12, 2, 10, 6, 4, 4, 0, 6, 6, 16, 0, 6,
                            10, 7, 14, 18, 16, 6, 6,
                        ],
                        [
                            6, 10, 16, 14, 6, 6, 4, 20, 18, 12, 7, 10, 6, 6, 4, 4, 20, 2, 16, 12, 4, 4, 18, 14, 12, 12,
                            4, 10, 10, 7, 2, 6,
                        ],
                    ],
                    fH4_3: [
                        [
                            16, 16, 18, 18, 16, 16, 16, 18, 18, 18, 7, 14, 14, 10, 10, 18, 18, 18, 16, 16, 7, 16, 16,
                            16, 20, 20, 10, 12, 18, 18, 12,
                        ],
                        [
                            14, 14, 7, 16, 16, 18, 18, 10, 18, 18, 18, 10, 10, 16, 16, 16, 12, 20, 20, 18, 18, 18, 12,
                            16, 16, 0, 18, 18, 16, 16, 16, 7, 0,
                        ],
                        [
                            16, 16, 12, 16, 16, 16, 0, 12, 18, 18, 18, 10, 10, 0, 16, 16, 16, 18, 18, 18, 14, 14, 18,
                            18, 16, 16, 20, 20, 10, 18, 18,
                        ],
                    ],
                    fH3_0: [
                        [5, 14, 16, 5, 18, 12, 5, 12, 10, 5, 8, 18, 5, 10, 18, 5, 14, 20, 5, 14, 16, 5, 12, 16],
                        [5, 10, 14, 5, 18, 12, 5, 18, 16, 5, 14, 8, 5, 16, 12, 5, 16, 18, 5, 12, 14, 5, 20, 10],
                        [5, 12, 16, 5, 18, 14, 5, 12, 10, 5, 20, 14, 5, 8, 16, 5, 18, 14, 5, 16, 18, 5, 10, 12],
                    ],
                    fH3_1: [
                        [0, 12, 18, 0, 10, 14, 0, 8, 16, 0, 18, 16, 0, 14, 20],
                        [0, 12, 8, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 20, 18],
                        [0, 16, 10, 0, 14, 12, 0, 18, 20, 0, 16, 14, 0, 8, 18],
                    ],
                    fH3_2: [
                        [
                            10, 2, 0, 18, 4, 4, 12, 4, 16, 12, 12, 8, 8, 4, 20, 12, 12, 14, 10, 18, 0, 14, 8, 2, 16, 8,
                            4, 4, 20, 10, 10, 12,
                        ],
                        [
                            4, 8, 8, 5, 2, 4, 4, 18, 14, 20, 10, 10, 8, 4, 20, 8, 2, 10, 12, 4, 4, 0, 12, 12, 16, 0, 12,
                            10, 5, 14, 18, 16, 12, 12,
                        ],
                        [
                            12, 10, 16, 14, 12, 12, 4, 20, 18, 8, 5, 10, 12, 12, 4, 4, 20, 2, 16, 8, 4, 4, 18, 14, 8, 8,
                            4, 10, 10, 5, 2, 12,
                        ],
                    ],
                    fH3_3: [
                        [
                            16, 16, 18, 18, 16, 16, 16, 18, 18, 18, 5, 14, 14, 10, 10, 18, 18, 18, 16, 16, 5, 16, 16,
                            16, 20, 20, 10, 8, 18, 18, 8,
                        ],
                        [
                            14, 14, 5, 16, 16, 18, 18, 10, 18, 18, 18, 10, 10, 16, 16, 16, 8, 20, 20, 18, 18, 18, 8, 16,
                            16, 0, 18, 18, 16, 16, 16, 5, 0,
                        ],
                        [
                            16, 16, 8, 16, 16, 16, 0, 8, 18, 18, 18, 10, 10, 0, 16, 16, 16, 18, 18, 18, 14, 14, 18, 18,
                            16, 16, 20, 20, 10, 18, 18,
                        ],
                    ],
                    fH2_0: [
                        [3, 14, 16, 3, 18, 12, 3, 12, 10, 3, 8, 18, 3, 10, 18, 3, 14, 6, 3, 14, 16, 3, 12, 16],
                        [3, 10, 14, 3, 18, 12, 3, 18, 16, 3, 14, 8, 3, 16, 12, 3, 16, 18, 3, 12, 14, 3, 6, 10],
                        [3, 12, 16, 3, 18, 14, 3, 12, 10, 3, 6, 14, 3, 8, 16, 3, 18, 14, 3, 16, 18, 3, 10, 12],
                    ],
                    fH2_1: [
                        [0, 12, 18, 0, 10, 14, 0, 8, 16, 0, 18, 16, 0, 14, 6],
                        [0, 12, 8, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 6, 18],
                        [0, 16, 10, 0, 14, 12, 0, 18, 6, 0, 16, 14, 0, 8, 18],
                    ],
                    fH2_2: [
                        [
                            6, 10, 2, 14, 16, 18, 16, 20, 0, 2, 8, 8, 10, 10, 8, 12, 0, 6, 20, 18, 10, 2, 6, 6, 2, 6, 6,
                            8, 12, 14,
                        ],
                        [
                            6, 12, 2, 2, 8, 12, 0, 8, 8, 2, 10, 10, 2, 20, 10, 3, 6, 6, 16, 6, 3, 10, 14, 8, 0, 18, 20,
                            16, 18, 14, 6, 6, 0,
                        ],
                        [
                            14, 10, 6, 12, 10, 10, 3, 6, 6, 3, 6, 2, 14, 2, 16, 2, 8, 8, 12, 8, 10, 20, 2, 18, 6, 6, 20,
                            18, 16, 8,
                        ],
                    ],
                    fH2_3: [
                        [
                            20, 20, 12, 16, 16, 10, 20, 20, 20, 8, 20, 20, 14, 14, 3, 14, 14, 3, 20, 20, 20, 12, 14, 14,
                            14, 10, 18, 18, 14, 14, 14,
                        ],
                        [
                            8, 12, 20, 20, 20, 16, 16, 0, 3, 20, 20, 3, 10, 14, 14, 14, 12, 14, 14, 20, 20, 20, 18, 18,
                            14, 14, 10, 14, 14, 14, 20, 20, 0,
                        ],
                        [
                            14, 14, 14, 20, 20, 12, 14, 14, 10, 20, 20, 20, 8, 20, 20, 12, 20, 20, 20, 0, 16, 16, 14,
                            14, 14, 10, 18, 18, 14, 14, 0,
                        ],
                    ],
                    fH1_0: [
                        [1, 14, 16, 1, 18, 12, 1, 12, 10, 1, 8, 18, 1, 4, 18, 1, 14, 6, 1, 14, 16, 1, 12, 16],
                        [1, 10, 14, 1, 18, 12, 1, 18, 16, 1, 14, 8, 1, 16, 12, 1, 16, 18, 1, 12, 14, 1, 6, 10],
                        [1, 12, 16, 1, 18, 14, 1, 12, 10, 1, 6, 14, 1, 8, 16, 1, 18, 14, 1, 16, 18, 1, 10, 12],
                    ],
                    fH1_1: [
                        [0, 12, 18, 0, 10, 14, 0, 8, 16, 0, 18, 16, 0, 14, 6],
                        [0, 12, 8, 0, 18, 14, 0, 16, 10, 0, 16, 14, 0, 6, 18],
                        [0, 16, 10, 0, 14, 12, 0, 18, 6, 0, 16, 14, 0, 8, 18],
                    ],
                    fH1_2: [
                        [
                            16, 20, 12, 4, 8, 8, 18, 12, 4, 8, 10, 10, 16, 14, 18, 20, 6, 6, 14, 4, 4, 0, 10, 8, 6, 4,
                            4, 0, 6,
                        ],
                        [
                            4, 4, 4, 0, 12, 10, 8, 8, 20, 0, 20, 14, 6, 16, 14, 1, 10, 10, 8, 12, 16, 18, 1, 6, 6, 18,
                            8, 4, 4, 6, 4,
                        ],
                        [
                            12, 18, 8, 8, 14, 10, 6, 6, 4, 4, 12, 4, 18, 8, 1, 6, 10, 10, 1, 20, 16, 4, 16, 8, 6, 20,
                            14, 4, 4,
                        ],
                    ],
                    fH1_3: [
                        [10, 20, 20, 1, 18, 16, 16, 20, 16, 14, 12, 16, 16, 16, 18, 1, 14, 20, 20, 20],
                        [1, 14, 16, 16, 16, 0, 18, 12, 20, 20, 20, 18, 20, 16, 16, 1, 14, 0, 20, 20, 16, 10],
                        [20, 20, 14, 16, 18, 20, 12, 14, 10, 16, 16, 0, 18, 20, 20, 20, 16, 16, 16, 18],
                    ],
                },
            },
        };
    }
}
